import { calculateAge } from "./dateUtils";

const SIBLING_FLAG_KEYS = [
    "hasSiblingInSchool",
    "hasSiblingInClass",
    "hasSiblingAssigned",
    "hasSiblingPlacement",
    "hasSiblingWithPlacement",
    "priorityHasSibling",
    "priorityHasSiblings",
    "prioritySiblingPlaced",
    "prioritySibling",
    "siblingPriority",
];

const siblingMatchesPriorityFlag = (child) => {
    if (!child) return undefined;
    const key = SIBLING_FLAG_KEYS.find((k) => typeof child?.[k] === "boolean");
    return key ? child[key] : undefined;
};

const isSiblingEligibleForPriority = (sibling) => {
    if (!sibling) return false;
    if (sibling.waiting !== false) return false;
    if (sibling.withdrawnAt) return false;
    if (sibling.deceasedAt) return false;
    return true;
};

export function calculatePriorityScore(child, allChildren, classrooms, siblingsByChildMap = null) {
    if (!child) return 0;

    let score = 0;

    const today = new Date();
    const registrationDate = child.dateRegistration ? new Date(child.dateRegistration) : null;
    const age = calculateAge(child.dateBirth);

    child.priorityAppliedRules = [];

    const source = Array.isArray(allChildren) ? allChildren : [];
    const siblingPriorityFlag = siblingMatchesPriorityFlag(child);

    let hasSiblingsInClass = false;

    if (typeof siblingPriorityFlag === "boolean") {
        hasSiblingsInClass = siblingPriorityFlag;
    } else if (
        siblingsByChildMap &&
        child.id != null &&
        Array.isArray(siblingsByChildMap[child.id])
    ) {
        const siblingIds = siblingsByChildMap[child.id];
        hasSiblingsInClass = siblingIds.some((siblingId) => {
            const sibling = source.find((candidate) => candidate?.id === siblingId);
            return isSiblingEligibleForPriority(sibling);
        });
    } else {
        hasSiblingsInClass = source.some(
            (candidate) =>
                candidate &&
                candidate.id !== child.id &&
                candidate.familyId === child.familyId &&
                isSiblingEligibleForPriority(candidate)
        );
    }

    if (hasSiblingsInClass) {
        score += 3;
        child.priorityAppliedRules.push("siblings");
    }

    if (child.committed) {
        score += 2;
        child.priorityAppliedRules.push("committed");
    }

    if (age >= 5) {
        score += 1;
        child.priorityAppliedRules.push("age");
    }

    if (registrationDate instanceof Date && !Number.isNaN(registrationDate.valueOf())) {
        const daysSinceRegistration = (today - registrationDate) / (1000 * 60 * 60 * 24);
        if (daysSinceRegistration > 180) {
            score += 1;
            child.priorityAppliedRules.push("registration");
        }
    }

    if (age < 2.5) {
        score -= 2;
        child.priorityAppliedRules.push("too_young");
    }

    if (!child.waiting && child.classroomId) {
        score -= 1;
        child.priorityAppliedRules.push("double_status");
    }

    return score;
}
